module.exports = __webpack_public_path__ + "static/img/culture6.6c3863fd.jpg";